import { createContext, useState } from 'react';
import { useQuery, registerQuery } from 'data-fetching-client';
import { getIsThemePreview, getPortalName } from '../utils/metadata';
import { Metrics } from '../utils/metrics';
import { jsx as _jsx } from "react/jsx-runtime";
const PortalDataContext = /*#__PURE__*/createContext(null);
export const FETCH_BRAND_DATA = registerQuery({
  fieldName: 'brandData',
  fetcher: async () => {
    const portalName = getPortalName();
    if (!portalName) {
      throw new Error('Missing portalName');
    }
    const isThemePreviewer = getIsThemePreview();
    const basePath = `/hs/portals/${portalName}/brand`;
    const searchParams = new URLSearchParams(window.location.search);
    const previewToken = searchParams.get('hs_preview');
    const themeSettingsVersion = searchParams.get('theme_settings_version');
    let queryString = '';
    if (isThemePreviewer) {
      const brandParams = new URLSearchParams();
      if (previewToken) {
        brandParams.set('hs_preview', previewToken);
      }
      if (themeSettingsVersion) {
        brandParams.set('theme_settings_version', themeSettingsVersion);
      }
      queryString = brandParams.toString();
    }
    const requestUrl = queryString ? `${basePath}?${queryString}` : basePath;
    const brandFetchStart = performance.now();
    let res;
    try {
      res = await fetch(requestUrl);
    } catch (e) {
      Metrics.counter('brand-fetch-error').increment();
      throw new Error('Failed to fetch brand data', {
        cause: e
      });
    }
    if (!res.ok) {
      Metrics.counter('brand-fetch-error').increment();
      console.error(`Brand data fetch failed: ${res.status} ${res.statusText}`);
      throw new Error('Failed to fetch brand data');
    }
    const data = await res.json();
    Metrics.timer('brand-fetch').update(performance.now() - brandFetchStart);
    return data;
  }
});
export function PortalDataProvider({
  children,
  initialData
}) {
  const [portalData, setPortalData] = useState(initialData !== null && initialData !== void 0 ? initialData : null);
  return /*#__PURE__*/_jsx(PortalDataContext.Provider, {
    value: {
      portalData,
      setPortalData
    },
    children: children
  });
}
export function useBrandData() {
  const {
    data
  } = useQuery(FETCH_BRAND_DATA);
  return data === null || data === void 0 ? void 0 : data.brandData;
}
export function usePortalData() {
  const {
    data
  } = useQuery(FETCH_BRAND_DATA);
  return {
    portalData: data === null || data === void 0 ? void 0 : data.brandData
  };
}
export function useBrandSettings() {
  var _portalData$context;
  const {
    portalData
  } = usePortalData();
  return portalData === null || portalData === void 0 || (_portalData$context = portalData.context) === null || _portalData$context === void 0 ? void 0 : _portalData$context.brandSettings;
}
export function useFavicon() {
  var _brandSettings$primar;
  const brandSettings = useBrandSettings();
  return (_brandSettings$primar = brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.primaryFavicon) !== null && _brandSettings$primar !== void 0 ? _brandSettings$primar : brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.favicon;
}
export function useLogo() {
  var _brandSettings$primar2;
  const brandSettings = useBrandSettings();
  return (_brandSettings$primar2 = brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.primaryLogo) !== null && _brandSettings$primar2 !== void 0 ? _brandSettings$primar2 : brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.logo;
}